"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.triggerResize = exports.onResize = void 0;

var _onLoad = require("./onLoad");

var _events = require("./events");

var executeCallback = function executeCallback(callback) {
  try {
    callback();
  } catch (err) {
    console.log('onResize error', err);
  }
};

var callbacks = [];
var timeoutInterval = -1;
/**
 * Registers a callback to be called when the page is resized
 * @param {function} callback
 * @example
 *
 * import { onResize } from '@demant/wdh';
 *
 * onLoad(() => {
 *   // Code executes when the page is resized
 * });
 */

var onResize = function onResize(callback) {
  callbacks.push(callback);
  executeCallback(callback);
};

exports.onResize = onResize;

var executeCallbacks = function executeCallbacks() {
  var callback;
  var i;
  var len;

  for (i = 0, len = callbacks.length; i < len; i += 1) {
    callback = callbacks[i];
    executeCallback(callback);
  }

  timeoutInterval = -1;
  setTimeout(function () {
    (0, _events.triggerEvent)(_events.EVENTS.RESIZE_DONE);
  });
};

exports.triggerResize = executeCallbacks;
window.top.addEventListener('resize', function () {
  if (timeoutInterval > -1) {
    clearTimeout(timeoutInterval);
  }

  timeoutInterval = setTimeout(function () {
    executeCallbacks();
  }, 300);
});
(0, _onLoad.onLoad)(function () {
  setTimeout(function () {
    executeCallbacks();
  }, 0);
});